// Path
export const ANALYTICS_METRIC_END_POINT: string = "analytics/dashboard/matrics";
export const ANALYTICS_GRAPH_END_POINT: string = "analytics/dashboard/graphs";
export const SUMMARY_REPORT_CSV_END_POINT: string = "analytics/dashboard/summary_report";
export const ARS_REPORT_CSV_END_POINT: string = "analytics/dashboard/ars_report";
export const GUIDE_LIVE_MODELS_END_POINT: string = "analytics/dashboard/guide/live_models";
export const PAGE_TITLE:string = "Performance";

// Date Menu Constants
export const TODAY: string = "Today(Timegrain-2H)";
export const YESTERDAY: string = "Yesterday(Timegrain-2H)";
export const LAST_7_DAYS: string = "Last 7 days(Timegrain-1D)";
export const LAST_30_DAYS: string = "Last 30 days(Timegrain-1D)";
export const LAST_MONTH: string = "Last Month(Timegrain-1D)";
export const LAST_3_MONTHS: string = "Last 3 Months(Timegrain-1W)";
export const THIS_YEAR_2W: string = "This year(Timegrain-2W)";
export const THIS_YEAR_1W: string = "This year(Timegrain-1W)";
export const THIS_YEAR_1M: string = "This year(Timegrain-1M)";
export const LAST_YEAR_1M: string = "Last year(Timegrain-1M)";

// Date Compared Constants
export const NONE: string = "None";
export const PREVIOS_PERIOD: string = "Previous Period";
export const PRESENT: string = "Present";

export const TIME_ZONE_MESSAGE: string = 'From start date, up to and including end date';
export const TIME_ZONE_LIMIT_MESSAGE: string = 'Please select a date range within the last three months for the reports.';
export const GENERATE_REPORT_MESSAGE: string = 'The generated report will be downloaded to the Downloads folder.';
export const COMMEND_REPORT: string = 'COMMEND';
export const SUMMARY_REPORT: string = 'SUMMARY';

// Granularity
export const PT2H: string = "PT2H";
export const P1D: string = "P1D";
export const P1W: string = "P1W";
export const P1M: string = "P1M";

export const DEFAULT_TIMEZONE = 'UTC';
export const DEFAULT_HEIGHT = 350;

